export const TravelData = [
  {
    continent: "Asia",
    countries: [
      {
        name: "Bharat",
        regions: {
          North: [
            {
              name: "Agra",
              state: "Uttar Pradesh",
              type: "Historical",
              famousFor: "Taj Mahal",
              image:
                "https://upload.wikimedia.org/wikipedia/commons/d/da/Taj-Mahal.jpg",
              googleKeyword: "Taj Mahal Agra",
            },
            {
              name: "Jaipur",
              state: "Rajasthan",
              type: "Heritage",
              famousFor: "Amber Fort, City Palace",
              image:
                "https://images.wanderon.in/blogs/new/2024/05/amber-fort.jpg",
              googleKeyword: "Amber Fort Jaipur",
            },
            {
              name: "Ayodhya",
              state: "Uttar Pradesh",
              type: "Religious",
              famousFor: "Ram Mandir, Saryu Ghat",
              image:
                "https://swarajya.gumlet.io/swarajya/2024-01/e940be54-6da0-483b-bd60-18c131b07974/Screenshot_2024_01_23_at_9_53_40_AM.png?w=610&q=50&compress=true&format=auto",
              googleKeyword: "Ram Mandir Ayodhya",
            },
            {
              name: "Delhi",
              state: "Delhi",
              type: "Historical/Urban",
              famousFor: "Red Fort, India Gate",
              image:
                "https://media.istockphoto.com/id/530741074/photo/red-fort-lal-qila-with-indian-flag-delhi-india.jpg?s=612x612&w=0&k=20&c=7BTI-dgQNPPTq2yARrwIBf2yIqO4PUPX1EJY5ITIyoM=",
              googleKeyword: "India Gate Delhi",
            },
            {
              name: "Varanasi",
              state: "Uttar Pradesh",
              type: "Spiritual",
              famousFor: "Ganga Aarti, Kashi Vishwanath Temple",
              image:
                "https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Ahilya_Ghat_by_the_Ganges%2C_Varanasi.jpg/960px-Ahilya_Ghat_by_the_Ganges%2C_Varanasi.jpg",
              googleKeyword: "Ganga Aarti Varanasi",
            },
            {
              name: "Amritsar",
              state: "Punjab",
              type: "Religious",
              famousFor: "Golden Temple",
              image:
                "https://www.savaari.com/blog/wp-content/uploads/2017/12/Amritsar-1.jpg",
              googleKeyword: "Golden Temple Amritsar",
            },
            {
              name: "Shimla",
              state: "Himachal Pradesh",
              type: "Hill Station",
              famousFor: "Mall Road, Ridge",
              image:
                "https://www.stayvista.com/blog/wp-content/uploads/2024/07/Ridge_Shimla.jpg",
              googleKeyword: "Shimla Mall Road",
            },
            {
              name: "Manali",
              state: "Himachal Pradesh",
              type: "Adventure",
              famousFor: "Snow, Rohtang Pass",
              image:
                "https://www.oyorooms.com/travel-guide/wp-content/uploads/2019/11/Top-4-Indian-skiing-destinations-Solang.webp",
              googleKeyword: "Manali Rohtang Pass",
            },
            {
              name: "Leh-Ladakh",
              state: "Ladakh",
              type: "Adventure",
              famousFor: "Pangong Lake, Monasteries",
              image:
                "https://thesknetworks.com/wp-content/uploads/2021/11/Leh-LadakhTour-and-Travel-package.webp",
              googleKeyword: "Pangong Lake Ladakh",
            },
          ],
          South: [
            {
              name: "Mysuru",
              state: "Karnataka",
              type: "Historical",
              famousFor: "Mysore Palace, Dussehra",
              image:
                "https://cdn.britannica.com/27/242227-050-48358A10/Mysore-Palace-Mysuru-Karnataka-India.jpg",
              googleKeyword: "Mysore Palace Mysuru",
            },
            {
              name: "Tirupati",
              state: "Andhra Pradesh",
              type: "Religious",
              famousFor: "Tirumala Venkateswara Temple",
              image:
                "https://upload.wikimedia.org/wikipedia/commons/4/4e/Tirumala_Anand_nilayam4653.jpg",
              googleKeyword: "Tirupati Balaji Temple",
            },
            {
              name: "Hampi",
              state: "Karnataka",
              type: "UNESCO Heritage",
              famousFor: "Ancient ruins, Temples",
              image:
                "https://revolvingcompass.com/wp/wp-content/uploads/2024/02/VijayaVittala_3.jpg",
              googleKeyword: "Hampi ruins Karnataka",
            },
            {
              name: "Ooty",
              state: "Tamil Nadu",
              type: "Hill Station",
              famousFor: "Botanical Gardens, Nilgiris",
              image:
                "https://assets.simplotel.com/simplotel/image/upload/x_211,y_454,w_3132,h_1761,r_0/q_80,w_900,h_506,dpr_1,f_auto,fl_progressive,c_limit/mango-hill-shola-ooty/Drone_1",
              googleKeyword: "Ooty Botanical Gardens",
            },
            {
              name: "Madurai",
              state: "Tamil Nadu",
              type: "Spiritual",
              famousFor: "Meenakshi Amman Temple",
              image:
                "https://static.wixstatic.com/media/36a61e_354a22be934b4cb4acfe746a47b83ebf~mv2_d_4368_2779_s_4_2.jpg/v1/fill/w_980,h_623,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/36a61e_354a22be934b4cb4acfe746a47b83ebf~mv2_d_4368_2779_s_4_2.jpg",
              googleKeyword: "Meenakshi Temple Madurai",
            },
            {
              name: "Rameswaram",
              state: "Tamil Nadu",
              type: "Religious",
              famousFor: "Ramanathaswamy Temple",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhGJTdrhIsxjh1uQiOCXptKRHK87gWOFuAxg&s",
              googleKeyword: "Ramanathaswamy Temple Rameswaram",
            },
            {
              name: "Alleppey",
              state: "Kerala",
              type: "Backwaters",
              famousFor: "Houseboats, Lagoons",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQY7IFWxi1mX2LIhz7ZA2s1IiJ2Y_lsB2XUOg&s",
              googleKeyword: "Alleppey Houseboats",
            },
            {
              name: "Munnar",
              state: "Kerala",
              type: "Hill Station",
              famousFor: "Tea Estates, Scenery",
              image:
                "https://www.sreestours.com/blog/wp-content/uploads/2014/07/Munnar_hillstation_kerala.jpg",
              googleKeyword: "Munnar Tea Estates",
            },
            {
              name: "Coorg",
              state: "Karnataka",
              type: "Hill Station",
              famousFor: "Coffee Plantations, Waterfalls",
              image:
                "https://r2imghtlak.mmtcdn.com/r2-mmt-htl-image/htl-imgs/202308041300371940-7084d4e89b5d11eea6ea0a58a9feac02.jpg",
              googleKeyword: "Coorg Coffee Plantations",
            },
          ],
          East: [
            {
              name: "Kolkata",
              state: "West Bengal",
              type: "Cultural",
              famousFor: "Victoria Memorial, Durga Puja",
              image:
                "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Victoria_Memorial_By_Saprativa.jpg/960px-Victoria_Memorial_By_Saprativa.jpg",
              googleKeyword: "Victoria Memorial Kolkata",
            },
            {
              name: "Darjeeling",
              state: "West Bengal",
              type: "Hill Station",
              famousFor: "Tea Gardens, Toy Train",
              image:
                "https://i1.wp.com/udaanhotels.com/wp-content/uploads/2023/12/tea-garden-darjeeling.jpg?fit=1024%2C646&ssl=1",
              googleKeyword: "Darjeeling Toy Train",
            },
            {
              name: "Puri",
              state: "Odisha",
              type: "Religious",
              famousFor: "Jagannath Temple, Beach",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEy4KRPdf-qxLOiG5zefWjWwrMG98K9AHIUA&s",
              googleKeyword: "Jagannath Temple Puri",
            },
            {
              name: "Bhubaneswar",
              state: "Odisha",
              type: "Temple City",
              famousFor: "Lingaraj Temple",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTUamrqtgpiJmQWyQQg9b7nipYywm0uGbHxKg&s",
              googleKeyword: "Lingaraj Temple Bhubaneswar",
            },
            {
              name: "Konark",
              state: "Odisha",
              type: "UNESCO Heritage",
              famousFor: "Sun Temple",
              image:
                "https://kevinstandagephotography.wordpress.com/wp-content/uploads/2020/03/ksp_6402-2-1.jpg?w=1024",
              googleKeyword: "Sun Temple Konark",
            },
            {
              name: "Gangtok",
              state: "Sikkim",
              type: "Scenic",
              famousFor: "Tsomgo Lake, Monasteries",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRv1h2CW3z4jyZ5nOq9weM3H1nJ0rvYo8NPYA&s",
              googleKeyword: "Tsomgo Lake Gangtok",
            },
            {
              name: "Kaziranga",
              state: "Assam",
              type: "Wildlife",
              famousFor: "One-horned Rhino",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRbSzpbu2eO0CYrHxwa7XLJZt17iTQrVd22tA&s",
              googleKeyword: "Kaziranga National Park",
            },
            {
              name: "Sundarbans",
              state: "West Bengal",
              type: "Wildlife",
              famousFor: "Mangrove Forests, Royal Bengal Tiger",
              image:
                "https://sevennaturalwonders.org/wp-content/uploads/2023/11/Sundarban-National-Park-mangroves.jpg",
              googleKeyword: "Sundarbans Mangrove Forest",
            },
          ],
          West: [
            {
              name: "Goa",
              state: "Goa",
              type: "Beach",
              famousFor: "Beaches, Nightlife, Portuguese heritage",
              image:
                "https://static.businessworld.in/Untitled%20design%20-%202024-12-31T052430.892_20241231105033_original_image_31.webp",
              googleKeyword: "Goa Beaches",
            },
            {
              name: "Mumbai",
              state: "Maharashtra",
              type: "Urban",
              famousFor: "Gateway of India, Marine Drive",
              image:
                "https://c.ndtvimg.com/2025-02/ou6t095g_mumbai_625x300_21_February_25.jpg?im=FaceCrop,algorithm=dnn,width=1200,height=738",
              googleKeyword: "Gateway of India Mumbai",
            },
            {
              name: "Udaipur",
              state: "Rajasthan",
              type: "Romantic",
              famousFor: "City of Lakes, Palaces",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSE-ACCXRFoBA33tufqKmJR5NezTVZJQgYHtg&s",
              googleKeyword: "Udaipur City Palace",
            },
            {
              name: "Jaisalmer",
              state: "Rajasthan",
              type: "Desert",
              famousFor: "Golden Fort, Sand Dunes",
              image:
                "https://www.setmytrip.in/wp-content/uploads/2024/03/IMG_20230104_165121-1067x800.jpg",
              googleKeyword: "Jaisalmer Fort",
            },
            {
              name: "Ahmedabad",
              state: "Gujarat",
              type: "Cultural/Heritage",
              famousFor: "Sabarmati Ashram, Pol Houses",
              image:
                "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Ahemdabad_Skyline.jpg/250px-Ahemdabad_Skyline.jpg",
              googleKeyword: "Sabarmati Ashram Ahmedabad",
            },
            {
              name: "Gir National Park",
              state: "Gujarat",
              type: "Wildlife",
              famousFor: "Asiatic Lions",
              image:
                "https://www.asianadventures.net/sites/default/files/cocoon/gir-national-park-safari.jpg",
              googleKeyword: "Gir National Park",
            },
            {
              name: "Mount Abu",
              state: "Rajasthan",
              type: "Hill Station",
              famousFor: "Dilwara Temples",
              image:
                "https://xplro.com/wp-content/uploads/2024/09/Mount-Abu-jpg.webp",
              googleKeyword: "Dilwara Temples Mount Abu",
            },
            {
              name: "Sasan Gir",
              state: "Gujarat",
              type: "Wildlife",
              famousFor: "Asiatic Lion Sanctuary",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYyy_imcmAmOC31V1pYtE36lCL4_atAOtclA&s",
              googleKeyword: "Asiatic Lion Sasan Gir",
            },
          ],
        },
      },
      {
        name: "China",
        regions: {
          Cities: [
            {
              name: "Beijing",
              state: "Beijing",
              type: "Historical/Urban",
              famousFor: "Great Wall, Forbidden City",
              image:
                "https://www.thechinajourney.com/wp-content/uploads/2024/09/beijing-photo-for-pc-banner-1024x682.webp",
              googleKeyword: "Forbidden City Beijing",
            },
            {
              name: "Shanghai",
              state: "Shanghai",
              type: "Urban",
              famousFor: "The Bund, Oriental Pearl Tower",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRaixKTHyRWOhQttO8lG0_uMd-MF5u-oXY69g&s",
              googleKeyword: "The Bund Shanghai",
            },
            {
              name: "Xi'an",
              state: "Shaanxi",
              type: "Historical",
              famousFor: "Terracotta Army",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlu-B1gKXvd2sNg3MzscFBOfwLYUWmdIQ28g&s",
              googleKeyword: "Terracotta Army Xi'an",
            },
            {
              name: "Guilin",
              state: "Guangxi",
              type: "Natural Scenic",
              famousFor: "Karst Mountains, Li River",
              image:
                "https://res.klook.com/image/upload/activities/yxlndh6tbdxlpuikjmgg.webp",
              googleKeyword: "Li River Guilin",
            },
            {
              name: "Hangzhou",
              state: "Zhejiang",
              type: "Natural/Cultural",
              famousFor: "West Lake",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSKVqrMA0POndZuRMoimGtQZz7gvLK1Ugm1LQ&s",
              googleKeyword: "West Lake Hangzhou",
            },
            {
              name: "Chengdu",
              state: "Sichuan",
              type: "Wildlife/Cultural",
              famousFor: "Giant Panda Base",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT19Cwj9e-_acut4A6dXWcFG7tyY8niQLO3VA&s",
              googleKeyword: "Panda Base Chengdu",
            },
            {
              name: "Lijiang",
              state: "Yunnan",
              type: "Historical/Scenic",
              famousFor: "Old Town, Jade Dragon Snow Mountain",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTcsaFONHTFJMsVfK0_cHjj3zpzLpoNIYN4bA&s",
              googleKeyword: "Lijiang Old Town",
            },
            {
              name: "Zhangjiajie",
              state: "Hunan",
              type: "Natural Scenic",
              famousFor: "Avatar Mountains",
              image:
                "https://cdn.theatlantic.com/media/img/photo/2018/05/travel-monday-a-photo-trip-to-zhang/z01_1021238707/main_1500.jpg",
              googleKeyword: "Zhangjiajie Avatar Mountains",
            },
          ],
        },
      },
      {
        name: "Japan",
        regions: {
          Cities: [
            {
              name: "Tokyo",
              state: "Tokyo",
              type: "Urban",
              famousFor: "Shibuya Crossing, Tokyo Tower",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYSxd0lrp2BY1d4-_jQs6iMLFQB35XdwvtDg&s",
              googleKeyword: "Shibuya Crossing Tokyo",
            },
            {
              name: "Kyoto",
              state: "Kyoto",
              type: "Cultural/Heritage",
              famousFor: "Fushimi Inari Shrine, Kinkaku-ji",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQRoxridbYEXVA_34zVqKtMWJL77C9GbVsnaQ&s",
              googleKeyword: "Fushimi Inari Shrine Kyoto",
            },
            {
              name: "Osaka",
              state: "Osaka",
              type: "Urban/Cultural",
              famousFor: "Osaka Castle, Dotonbori",
              image:
                "https://travel.rakuten.com/contents/sites/contents/files/styles/max_1300x1300/public/2024-07/best-things-to-do-osaka_10.jpg?itok=4ThxtBHO",
              googleKeyword: "Osaka Castle",
            },
            {
              name: "Nara",
              state: "Nara",
              type: "Historical",
              famousFor: "Todai-ji Temple, Deer Park",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSNsVcOSu07wfkikljzuW3n5Ng-i2a8d1f4vQ&s",
              googleKeyword: "Todai-ji Temple Nara",
            },
            {
              name: "Hiroshima",
              state: "Hiroshima",
              type: "Historical",
              famousFor: "Peace Memorial Park",
              image:
                "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Atomic_Bomb_Dome_and_Motoyaso_River%2C_Hiroshima%2C_Northwest_view_20190417_1.jpg/330px-Atomic_Bomb_Dome_and_Motoyaso_River%2C_Hiroshima%2C_Northwest_view_20190417_1.jpg",
              googleKeyword: "Peace Memorial Park Hiroshima",
            },
            {
              name: "Hakone",
              state: "Kanagawa",
              type: "Natural",
              famousFor: "Hot Springs, Lake Ashi",
              image:
                "https://www.agoda.com/wp-content/uploads/2024/05/Mountain-Fuji-and-Lake-Ashi-with-Hakone-temple--980x700.jpg",
              googleKeyword: "Lake Ashi Hakone",
            },
            {
              name: "Sapporo",
              state: "Hokkaido",
              type: "Urban/Natural",
              famousFor: "Snow Festival, Beer Museum",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSb0BDABPsQ5QxSpdeSw4F0N1z0ZpdA5y12qQ&s",
              googleKeyword: "Sapporo Snow Festival",
            },
            {
              name: "Mount Fuji",
              state: "Honshu",
              type: "Natural",
              famousFor: "Japan's Highest Peak",
              image:
                "https://cdn-imgix.headout.com/media/images/22fba69863f7d95408b199a4796db8e8-Fujinomiya%205th%20Station.jpg?auto=format&w=1222.3999999999999&h=687.6&q=90&fit=crop&ar=16%3A9&crop=faces",
              googleKeyword: "Mount Fuji",
            },
          ],
        },
      },
      {
        name: "Malaysia",
        regions: {
          Cities: [
            {
              name: "Kuala Lumpur",
              state: "Kuala Lumpur",
              type: "Urban",
              famousFor: "Petronas Towers",
              image:
                "https://asianinsiders.com/wp-content/uploads/2023/06/Kuala-Lumpur-World-Class-Business-Hub-1100x619-1-768x432.jpg.webp",
              googleKeyword: "Petronas Towers Kuala Lumpur",
            },
            {
              name: "Penang",
              state: "Penang",
              type: "Cultural/Heritage",
              famousFor: "George Town, Street Food",
              image:
                "https://images.goway.com/production/styles/wide/s3/hero/iStock-1347154491.jpg?VersionId=xEmG24yuWvN4TKWw1oou3Jy5Fu91g7mu&itok=ts_84S1r",
              googleKeyword: "George Town Penang",
            },
            {
              name: "Langkawi",
              state: "Kedah",
              type: "Beach/Nature",
              famousFor: "Beaches, Cable Car",
              image:
                "https://pix10.agoda.net/hotelImages/10436/0/65b175ae16a4ce0502e6d32ba0ae31ab.jpg?ce=0&s=414x232",
              googleKeyword: "Langkawi Cable Car",
            },
            {
              name: "Cameron Highlands",
              state: "Pahang",
              type: "Hill Station",
              famousFor: "Tea Plantations",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTk3vJa2SIEASpEXAnJ1gRwBW4d3WnxMa01Tw&s",
              googleKeyword: "Cameron Highlands Tea Plantations",
            },
            {
              name: "Malacca",
              state: "Malacca",
              type: "Historical",
              famousFor: "Dutch Square, Jonker Street",
              image:
                "https://www.flamingotravels.co.in/_next/image?url=https%3A%2F%2Fimgcdn.flamingotravels.co.in%2FImages%2FPlacesOfInterest%2FFull-Day-Historical-Melaka-Tour-with-lunch-Local-Food-Kuala-Lumpur-Malaysia-Places-To-Visit-Intrest%20-%203.jpg&w=828&q=90",
              googleKeyword: "Dutch Square Malacca",
            },
            {
              name: "Taman Negara",
              state: "Pahang",
              type: "Rainforest",
              famousFor: "Wildlife, Canopy Walk",
              image:
                "https://c4.staticflickr.com/8/7080/27182372883_57c557489e_z.jpg",
              googleKeyword: "Taman Negara Malaysia",
            },
            {
              name: "Perhentian Islands",
              state: "Terengganu",
              type: "Beach",
              famousFor: "Snorkeling, Diving",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTiyDaPRxJX06FE5VQSR8xg9FINb5y6aWUdDQ&s",
              googleKeyword: "Perhentian Islands",
            },
            {
              name: "Ipoh",
              state: "Perak",
              type: "Cultural/Natural",
              famousFor: "Cave Temples",
              image:
                "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/1f/cb/62/31/night-view-of-swimming.jpg?w=900&h=500&s=1",
              googleKeyword: "Perak Cave Temple Ipoh",
            },
          ],
        },
      },
      {
        name: "United Arab Emirates",
        regions: {
          Cities: [
            {
              name: "Dubai",
              state: "Dubai",
              type: "Urban/Luxury",
              famousFor: "Burj Khalifa, Desert Safari",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9gnHjihqGG-HgmQw_tVwoYmIdL-oqDjRMSg&s",
              googleKeyword: "Dubai Burj Khalifa",
            },
            {
              name: "Abu Dhabi",
              state: "Abu Dhabi",
              type: "Urban/Cultural",
              famousFor: "Sheikh Zayed Mosque, Louvre",
              image:
                "https://yallaabudhabi.ae/wp-content/uploads/2023/08/Abu-Dhabi-2.jpg",
              googleKeyword: "Abu Dhabi Louvre",
            },
            {
              name: "Sharjah",
              state: "Sharjah",
              type: "Cultural/Traditional",
              famousFor: "Islamic Museum",
              image:
                "https://media.tacdn.com/media/attractions-splice-spp-674x446/06/d4/64/05.jpg",
              googleKeyword: "Sharjah Museum Islamic",
            },
            {
              name: "Fujairah",
              state: "Fujairah",
              type: "Coastal/Nature",
              famousFor: "Mountains, Beaches",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTuoGx0HvhN-8fsCUUW9yF8_JGqfszZt1GLvw&s",
              googleKeyword: "Fujairah beaches UAE",
            },
            {
              name: "Ajman",
              state: "Ajman",
              type: "Small City/Beach",
              famousFor: "Ajman Beach, Heritage",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQNuCTHFhM7oQ4EQMArmmAntHbPeJLMrYKWQ&s",
              googleKeyword: "Ajman beach UAE",
            },
            {
              name: "Ras Al Khaimah",
              state: "RAK",
              type: "Adventure/Nature",
              famousFor: "Jebel Jais, Hajar Mountains",
              image: "https://etimg.etb2bimg.com/photo/99875486.cms",
              googleKeyword: "Jebel Jais",
            },
            {
              name: "Al Ain",
              state: "Abu Dhabi",
              type: "Oasis/Cultural",
              famousFor: "Al Ain Oasis, Forts",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQEC3J_X3dwUTmpCSl6BR65jSyBOI2cLjfkoQ&s",
              googleKeyword: "Al Ain Oasis UAE",
            },
            {
              name: "Umm Al Quwain",
              state: "UAQ",
              type: "Peaceful/Beach",
              famousFor: "Water sports, Islands",
              image:
                "https://cdn.britannica.com/15/189715-004-E41FC1B3/Dubai-United-Arab-Emirates-Burj-Khalifa-top.jpg",
              googleKeyword: "Umm Al Quwain UAE",
            },
          ],
        },
      },
      {
        name: "Singapore",
        regions: {
          Cities: [
            {
              name: "Singapore",
              state: "Singapore",
              type: "Urban/Modern",
              famousFor: "Marina Bay Sands",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRbL9cl5kG8oMfVodwJe6-EO-Va7n6BGqGmIg&s",
              googleKeyword: "Marina Bay Sands Singapore",
            },
            {
              name: "Sentosa Island",
              state: "Singapore",
              type: "Island/Entertainment",
              famousFor: "Universal Studios",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRvhpKWlMxBIojRQA16wsn8RiUxBDL_8a1LAw&s",
              googleKeyword: "Sentosa Island Singapore",
            },
            {
              name: "Pulau Ubin",
              state: "Singapore",
              type: "Island/Nature",
              famousFor: "Cycling Trails, Kampong",
              image:
                "https://travellingtam.com/wp-content/uploads/2023/08/DSCF2404.jpg",
              googleKeyword: "Pulau Ubin",
            },
            {
              name: "St. John's Island",
              state: "Singapore",
              type: "Island/Relax",
              famousFor: "Picnics, Beaches",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYBSq8KQ0Ijms7VQNEB5PBCTdvOesshofwJA&s",
              googleKeyword: "St John's Island Singapore",
            },
            {
              name: "Lazarus Island",
              state: "Singapore",
              type: "Island/Beach",
              famousFor: "Clear Waters",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8ut9igN08wB2tVo-pDNVdH6tHTykGbvvHEQ&s",
              googleKeyword: "Lazarus Island Singapore",
            },
            {
              name: "Kusu Island",
              state: "Singapore",
              type: "Island/Heritage",
              famousFor: "Pilgrimage, Temple",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTCVBhgqW_tVb14--9ptH9SQ8A3DPVZrlV6Gw&s",
              googleKeyword: "Kusu Island Singapore",
            },
            {
              name: "Sisters' Islands",
              state: "Singapore",
              type: "Island/Marine",
              famousFor: "Marine Park",
              image:
                "https://cassette.sphdigital.com.sg/image/straitstimes/e6d3ad25bad6d97a50d19fe34b62efb8bb3e824aff136a5be15943478c2a8d9d",
              googleKeyword: "Sisters Islands Singapore",
            },
            {
              name: "Tekong Island",
              state: "Singapore",
              type: "Military/Restricted",
              famousFor: "Military Training",
              image:
                "https://images.wanderon.in/blogs/new/2024/12/places-to-visit-in-tekong-island-and-nearby-attractions.jpg",
              googleKeyword: "Pulau Tekong",
            },
          ],
        },
      },
      {
        name: "Thailand",
        regions: {
          Cities: [
            {
              name: "Bangkok",
              state: "Bangkok",
              type: "Urban/Cultural",
              famousFor: "Grand Palace",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXnSHOtD5DVpvRyoPkEpqSc0SzP91ENSwViw&s",
              googleKeyword: "Grand Palace Bangkok",
            },
            {
              name: "Chiang Mai",
              state: "Chiang Mai",
              type: "Nature/Cultural",
              famousFor: "Temples",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR3AdmJPs1K1y430jhlCTa5fXyb1iylmBLkjg&s",
              googleKeyword: "Chiang Mai Temples",
            },
            {
              name: "Phuket",
              state: "Phuket",
              type: "Beach/Resort",
              famousFor: "Beaches",
              image:
                "https://www.pelago.com/img/destinations/phuket/0502-0403_phuket-xlarge.jpg",
              googleKeyword: "Phuket Beach Thailand",
            },
            {
              name: "Krabi",
              state: "Krabi",
              type: "Beach/Scenic",
              famousFor: "Railay Beach",
              image:
                "https://www.qantas.com/travelinsider/en/explore/asia/thailand/things-to-do-krabi/_jcr_content/verticalGalleryMain/gallery/galleryItems/50_1726567773236.img.1440.high.jpg/1726567790887.jpg",
              googleKeyword: "Krabi Railay Beach",
            },
            {
              name: "Pattaya",
              state: "Chonburi",
              type: "Beach/Entertainment",
              famousFor: "Walking Street",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR-Jo96OWyU5Bc7MLs41rGbpuXJItauleEeww&s",
              googleKeyword: "Pattaya Thailand",
            },
            {
              name: "Ayutthaya",
              state: "Ayutthaya",
              type: "Historical",
              famousFor: "Ancient Ruins",
              image:
                "https://www.traveltalktours.com/wp-content/uploads/2022/01/shutterstock_367762952-1024x683.jpg",
              googleKeyword: "Ayutthaya Historical Park",
            },
            {
              name: "Hua Hin",
              state: "Prachuap",
              type: "Beach/Relax",
              famousFor: "Royal Beach",
              image:
                "https://cdn.i-scmp.com/sites/default/files/d8/images/canvas/2025/02/26/ac46e1b8-3e45-4939-8047-f77267a39d26_8b438ccb.jpg",
              googleKeyword: "Hua Hin Thailand",
            },
            {
              name: "Ko Samui",
              state: "Surat Thani",
              type: "Island/Beach",
              famousFor: "Beaches, Coconut Grove",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQDYcwfFVbAgc4_GGnCRJjYfXUMAPEDss4QWA&s",
              googleKeyword: "Koh Samui Thailand",
            },
          ],
        },
      },
      {
        name: "Maldives",
        regions: {
          Cities: [
            {
              name: "Malé",
              state: "Malé Atoll",
              type: "Island/Beach",
              famousFor: "Resorts",
              image:
                "https://www.livemoretravelmore.com/wp-content/uploads/2020/07/14625650018_fe95e6264a_c.jpg",
              googleKeyword: "Maldives resorts",
            },
            {
              name: "Vaadhoo Island",
              state: "Raa Atoll",
              type: "Island/Night Wonder",
              famousFor: "Bioluminescence",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbwTEfprvUo0KZzzVRcdN3US3eoSS6rFUt5Q&s",
              googleKeyword: "Vaadhoo Island Maldives",
            },
            {
              name: "Addu Atoll",
              state: "Southern Maldives",
              type: "Atoll/Exploration",
              famousFor: "Diving",
              image:
                "https://mediaim.expedia.com/destination/1/8009db2046e72d3abb829184decf3b39.jpg",
              googleKeyword: "Addu Atoll Maldives",
            },
            {
              name: "Maafushi",
              state: "Kaafu Atoll",
              type: "Local/Guesthouse",
              famousFor: "Budget Tourism",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSzpdPg2npqXO-9rqaPFzbuirJrhdptnv5MuA&s",
              googleKeyword: "Maafushi Maldives",
            },
            {
              name: "Baa Atoll",
              state: "Baa Atoll",
              type: "UNESCO Biosphere",
              famousFor: "Hanifaru Bay",
              image:
                "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2a/7f/95/0b/vakkaru-maldives.jpg?w=1200&h=-1&s=1",
              googleKeyword: "Baa Atoll Maldives",
            },
            {
              name: "Fuvahmulah",
              state: "Gnaviyani Atoll",
              type: "Island/Unique",
              famousFor: "Freshwater Lakes",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSkbEn6RShluLpPnRBDHBJ_tQRFW1lFD3_7Ig&s",
              googleKeyword: "Fuvahmulah Maldives",
            },
            {
              name: "Thulusdhoo",
              state: "Kaafu Atoll",
              type: "Surf/Local",
              famousFor: "Surfing",
              image:
                "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/14/f1/30/30/located-20-min-away-from.jpg?w=600&h=400&s=1",
              googleKeyword: "Thulusdhoo Maldives",
            },
            {
              name: "Hulhumalé",
              state: "Kaafu Atoll",
              type: "Reclaimed/Urban",
              famousFor: "Beach Park",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTL6_qcw4BO83-mh0I0Z1moyyMXF5UcZ6oCbQ&s",
              googleKeyword: "Hulhumale Maldives",
            },
          ],
        },
      },
      {
        name: "Turkey",
        regions: {
          Cities: [
            {
              name: "Istanbul",
              state: "Istanbul",
              type: "Historical/Cultural",
              famousFor: "Hagia Sophia",
              image:
                "https://content.tui.co.uk/adamtui/2021_2/11_16/1a4128b9-fad9-4b10-a026-accc011459d2/ACC_969732_shutterstock_721552321WebOriginalCompressed.jpg?i10c=img.resize(width:1080);img.crop(width:1080%2Cheight:608)",
              googleKeyword: "Hagia Sophia Istanbul",
            },
            {
              name: "Cappadocia",
              state: "Nevşehir",
              type: "Adventure/Scenic",
              famousFor: "Hot Air Balloons",
              image:
                "https://media.tacdn.com/media/attractions-splice-spp-674x446/0b/33/cf/d0.jpg",
              googleKeyword: "Cappadocia Turkey",
            },
            {
              name: "Antalya",
              state: "Antalya",
              type: "Resort/Beach",
              famousFor: "Turquoise Coast",
              image:
                "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0d/97/4c/d1/20151030-095049-largejpg.jpg?w=1200&h=-1&s=1",
              googleKeyword: "Antalya Turkey",
            },
            {
              name: "Izmir",
              state: "İzmir",
              type: "Urban/Coastal",
              famousFor: "Kordon, Agora",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSc0m3atqjnG8zeHI0rPbWca6RYLl476vxSfl0eaQTjSdK4D4rQ3eOBkUYIJVlYgqkwsLM&usqp=CAU",
              googleKeyword: "Izmir Turkey",
            },
            {
              name: "Ephesus",
              state: "İzmir Province",
              type: "Ancient/Archaeology",
              famousFor: "Ruins",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTuY7OGY5oPZAmJk2wP64aeE8xChPoUA9lHkg&s",
              googleKeyword: "Ephesus Turkey",
            },
            {
              name: "Pamukkale",
              state: "Denizli",
              type: "Natural/Wonder",
              famousFor: "Thermal Terraces",
              image:
                "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/11/16/4c/17/merveilleux.jpg?w=1200&h=-1&s=1",
              googleKeyword: "Pamukkale Turkey",
            },
            {
              name: "Bodrum",
              state: "Muğla",
              type: "Coastal/Resort",
              famousFor: "Nightlife, Castle",
              image:
                "https://kaplankaya.com/wp-content/uploads/2023/07/Screenshot-2023-07-06-at-15.50.58.png",
              googleKeyword: "Bodrum Turkey",
            },
            {
              name: "Göbekli Tepe",
              state: "Şanlıurfa",
              type: "Historical/Ancient",
              famousFor: "Prehistoric Temple",
              image:
                "https://www.optionstheedge.com/sites/default/files/field/featured-image/2024/gobekli_1.jpg",
              googleKeyword: "Gobekli Tepe Turkey",
            },
          ],
        },
      },
      {
        name: "Indonesia",
        regions: {
          Cities: [
            {
              name: "Bali",
              state: "Bali",
              type: "Beach/Cultural",
              famousFor: "Temples",
              image:
                "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0d/bf/10/29/parque-nacional-de-komodo.jpg?w=1200&h=700&s=1",
              googleKeyword: "Bali Indonesia",
            },
            {
              name: "Java (Jakarta)",
              state: "Jakarta",
              type: "Urban/Capital",
              famousFor: "National Monument",
              image:
                "https://deih43ym53wif.cloudfront.net/jakarta-indonesia-shutterstock_1281548488_233b890989.jpeg",
              googleKeyword: "Jakarta Indonesia",
            },
            {
              name: "Lombok",
              state: "West Nusa Tenggara",
              type: "Beach/Adventure",
              famousFor: "Mount Rinjani",
              image:
                "https://cdn.prod.website-files.com/66fab24d6dde4d79b3b50865/6784d8af1aafcaf427891156_6784d76a496bd1c1bf5eb516_PINK%2520BEACH.webp",
              googleKeyword: "Lombok Indonesia",
            },
            {
              name: "Sumatra (Medan)",
              state: "North Sumatra",
              type: "Nature/Cultural",
              famousFor: "Lake Toba",
              image:
                "https://content.r9cdn.net/rimg/dimg/47/90/52fe9be0-city-25417-169119e4e6d.jpg?width=1366&height=768&xhint=3230&yhint=2044&crop=true",
              googleKeyword: "Lake Toba Sumatra",
            },
            {
              name: "Sulawesi (Makassar)",
              state: "South Sulawesi",
              type: "Cultural/Coastal",
              famousFor: "Trans-Flores Strait",
              image:
                "https://www.cio.com/wp-content/uploads/2023/05/losari-beach-makassar-indonesia-at-night_adiartana_getty-100780895-orig.jpg?quality=50&strip=all&w=1024",
              googleKeyword: "Makassar Indonesia",
            },
            {
              name: "Komodo Island",
              state: "East Nusa Tenggara",
              type: "Wildlife/Nature",
              famousFor: "Komodo Dragons",
              image:
                "https://assets.bucketlistly.blog/sites/5adf778b6eabcc00190b75b1/content_entry5adf77af6eabcc00190b75b6/5b90f5e511c4100808dfeb90/files/komodo-island-backpacking-guide-main-image-900.jpg",
              googleKeyword: "Komodo Island",
            },
            {
              name: "Borneo (Kalimantan)",
              state: "Kalimantan",
              type: "Rainforest/Wildlife",
              famousFor: "Orangutans",
              image:
                "https://waybird.imgix.net/regions/kodak_images/000/001/140/original/iStock-1704122116.jpg?w=972&h=648&crop=fit&fit=min&dpr=1&q=50&auto=format",
              googleKeyword: "Borneo Indonesia",
            },
            {
              name: "Flores",
              state: "East Nusa Tenggara",
              type: "Cultural/Nature",
              famousFor: "Dragon’s Teeth, Kelimutu",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7V-UJztDfpNYrYXRFy9qRCnn1jVM6q-TYDw&s",
              googleKeyword: "Flores Indonesia",
            },
          ],
        },
      },
    ],
  },
  {
    continent: "Europe",
    countries: [
      {
        name: "France",
        regions: {
          Cities: [
            {
              name: "Paris",
              state: "Île-de-France",
              type: "Urban/Heritage",
              famousFor: "Eiffel Tower, Louvre",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLakFfK0oMeWqWWAPE7V-HLBCRdK0emNx_1Q&s",
              googleKeyword: "Eiffel Tower Paris",
            },
            {
              name: "Nice",
              state: "Provence-Alpes-Côte d'Azur",
              type: "Beach",
              famousFor: "French Riviera, Promenade des Anglais",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRvXSxp8bMX_BRMVGiAWnC9fNB-ONB1RPd0Ow&s",
              googleKeyword: "Promenade des Anglais Nice",
            },
            {
              name: "Lyon",
              state: "Auvergne-Rhône-Alpes",
              type: "Historical",
              famousFor: "Old Town, Culinary Scene",
              image:
                "https://assets.vogue.com/photos/5995ef90d50bdd172aa1b516/master/w_2560%2Cc_limit/00-lede-lyon-france-travel-guide.jpg",
              googleKeyword: "Lyon Old Town",
            },
            {
              name: "Versailles",
              state: "Île-de-France",
              type: "Heritage",
              famousFor: "Palace of Versailles",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTO9N5Krk8luL6nm9K9ojyjKZukniW505SFIQ&s",
              googleKeyword: "Palace of Versailles",
            },
            {
              name: "Mont Saint-Michel",
              state: "Normandy",
              type: "Historical",
              famousFor: "Island Abbey",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTd_541LnlYP-l2pNn1wsDeqLE8X91nikrO_w&s",
              googleKeyword: "Mont Saint Michel",
            },
            {
              name: "Chamonix",
              state: "Auvergne-Rhône-Alpes",
              type: "Mountain",
              famousFor: "Mont Blanc, Skiing",
              image:
                "https://europe.stripes.com/travel/how_to_spend_48_hours_in_chamonix_france.jpg/alternates/LANDSCAPE_910/europe-89863",
              googleKeyword: "Chamonix Mont Blanc",
            },
            {
              name: "Bordeaux",
              state: "Nouvelle-Aquitaine",
              type: "Wine Region",
              famousFor: "Wine Tours",
              image:
                "https://media.cntraveller.com/photos/66a228c17f2f46d1f43878d5/3:2/w_2121,h_1414,c_limit/river%20Garonne-GettyImages-1482994599.jpg",
              googleKeyword: "Bordeaux wine tours",
            },
            {
              name: "Strasbourg",
              state: "Grand Est",
              type: "Cultural",
              famousFor: "Cathedral, European Parliament",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTb3uKb05ji3zm-hbCPbcoupIqbAQx-OhVsbw&s",
              googleKeyword: "Strasbourg Cathedral",
            },
          ],
        },
      },
      {
        name: "Italy",
        regions: {
          Cities: [
            {
              name: "Rome",
              state: "Lazio",
              type: "Historical",
              famousFor: "Colosseum, Vatican City",
              image:
                "https://i.natgeofe.com/k/a6c9f195-de20-445d-9d36-745ef56042c5/OG_Colosseum_Ancient-Rome_KIDS_1122_3x2.jpg",
              googleKeyword: "Colosseum Rome",
            },
            {
              name: "Venice",
              state: "Veneto",
              type: "Romantic",
              famousFor: "Canals, St. Mark's Basilica",
              image:
                "https://cdn.britannica.com/62/153462-050-3D4F41AF/Grand-Canal-Venice.jpg",
              googleKeyword: "Venice canals",
            },
            {
              name: "Florence",
              state: "Tuscany",
              type: "Cultural",
              famousFor: "Uffizi Gallery, Duomo",
              image:
                "https://i0.wp.com/www.touristitaly.com/wp-content/uploads/2023/04/Florence-view-from-the-top-of-the-Duomo-with-Palazzo-Vecchio-e1682579398666.jpg?fit=2500%2C1493&ssl=1",
              googleKeyword: "Florence Duomo",
            },
            {
              name: "Milan",
              state: "Lombardy",
              type: "Urban",
              famousFor: "Duomo di Milano, Fashion",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQCjPSteke7Gu-PQBjb5gyLmZUuRmn5C2auiA&s",
              googleKeyword: "Duomo Milan",
            },
            {
              name: "Naples",
              state: "Campania",
              type: "Historical",
              famousFor: "Pompeii nearby, Pizza",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR0WipREdqPYJkgElGojY5JMBDKOeMOTJaMcw&s",
              googleKeyword: "Pompeii Naples",
            },
            {
              name: "Amalfi Coast",
              state: "Campania",
              type: "Scenic",
              famousFor: "Coastline, Towns",
              image:
                "https://images.squarespace-cdn.com/content/v1/5f9af6090c0a7348fa94da7e/1607123418336-86I3M7OTCSHXDHCOEH6N/IMG_6218-7.jpg",
              googleKeyword: "Amalfi Coast Italy",
            },
            {
              name: "Cinque Terre",
              state: "Liguria",
              type: "Scenic",
              famousFor: "Colorful Villages",
              image:
                "https://www.worldatlas.com/upload/6b/9e/92/manarola-cinque-terre-italy-jenifoto.jpg",
              googleKeyword: "Cinque Terre",
            },
            {
              name: "Sicily",
              state: "Sicily",
              type: "Historical/Natural",
              famousFor: "Mount Etna, Ancient Ruins",
              image:
                "https://www.paesana.com/hubfs/Blog/Sicily%20Italy%20landscape%20with%20water%20and%20homes%20in%20background.jpg",
              googleKeyword: "Mount Etna Sicily",
            },
          ],
        },
      },
      {
        name: "United Kingdom",
        regions: {
          Cities: [
            {
              name: "London",
              state: "England",
              type: "Urban",
              famousFor: "Big Ben, Buckingham Palace",
              image:
                "https://encrypted-tbn0.gstatic.com/licensed-image?q=tbn:ANd9GcRj8g2WGx2WKl5DjBWBUSrjKrxZ9s4_PGHPlZJi7Cth748HVkEG6BvXcPFQ7uyLUJfGmlKic1YO_LCZ7jepcZH2C5bUFSt2cpHY0uEIjA",
              googleKeyword: "Big Ben London",
            },
            {
              name: "Edinburgh",
              state: "Scotland",
              type: "Historical",
              famousFor: "Edinburgh Castle, Royal Mile",
              image:
                "https://i.natgeofe.com/n/63330ffd-a4a0-44d4-b429-139394fb3908/edinburgh.jpeg",
              googleKeyword: "Edinburgh Castle",
            },
            {
              name: "Bath",
              state: "England",
              type: "Historical",
              famousFor: "Roman Baths, Georgian architecture",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6YpnaVoz3gkS5WqasEw_8zGqVpJdbwuA_tQ&s",
              googleKeyword: "Roman Baths Bath",
            },
            {
              name: "Stonehenge",
              state: "Wiltshire",
              type: "Historical",
              famousFor: "Prehistoric monument",
              image:
                "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Stonehenge2007_07_30.jpg/960px-Stonehenge2007_07_30.jpg",
              googleKeyword: "Stonehenge",
            },
            {
              name: "Cambridge",
              state: "England",
              type: "Cultural",
              famousFor: "University, Punting",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSax2kg-d2Rcd6ezZ8Q3xIeAioqzq9ZUyCGiQ&s",
              googleKeyword: "King's College Cambridge",
            },
            {
              name: "Oxford",
              state: "England",
              type: "Cultural",
              famousFor: "University, Architecture",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSfpgu15afbqoAOF6HExGPMOQBlMfEzMXH7mA&s",
              googleKeyword: "Bodleian Library Oxford",
            },
            {
              name: "Liverpool",
              state: "England",
              type: "Cultural",
              famousFor: "The Beatles, Waterfront",
              image:
                "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Liverpoolcityskyline.jpg/960px-Liverpoolcityskyline.jpg",
              googleKeyword: "The Beatles Liverpool",
            },
            {
              name: "York",
              state: "England",
              type: "Historical",
              famousFor: "York Minster, Medieval Walls",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTxRT3X6MaNL77nyDwOOLt4KPBUKDip1D6v1w&s",
              googleKeyword: "York Minster",
            },
          ],
        },
      },
      {
        name: "Spain",
        regions: {
          Cities: [
            {
              name: "Barcelona",
              state: "Catalonia",
              type: "Urban/Architectural",
              famousFor: "Sagrada Familia, Park Güell",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTx8Ru6e57TCXClzp_8gGIFkFE1MraKvvmx4Q&s",
              googleKeyword: "Barcelona Sagrada Familia",
            },
            {
              name: "Madrid",
              state: "Community of Madrid",
              type: "Urban/Cultural",
              famousFor: "Royal Palace, Prado Museum",
              image:
                "https://a.travel-assets.com/findyours-php/viewfinder/images/res70/348000/348698-Madrid.jpg",
              googleKeyword: "Madrid Royal Palace",
            },
            {
              name: "Seville",
              state: "Andalusia",
              type: "Historical/Cultural",
              famousFor: "Alcazar, Flamenco Dance",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQyOXtH9eeDXPB1Zbtojgyqqs8-NKs_L9loNg&s",
              googleKeyword: "Seville Alcazar Spain",
            },
            {
              name: "Granada",
              state: "Andalusia",
              type: "Historical/Moorish",
              famousFor: "Alhambra Palace",
              image:
                "https://cdn-imgix.headout.com/media/images/58da77effa54b9c430bbabfd2a54f135-Alhambra%20Granada.jpeg?auto=format&w=1069.6000000000001&h=687.6&q=90&fit=crop&ar=14%3A9&crop=faces",
              googleKeyword: "Granada Alhambra",
            },
            {
              name: "Valencia",
              state: "Valencian Community",
              type: "Urban/Beach",
              famousFor: "City of Arts and Sciences",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSwOU3PXwPZUyI4Twn0qleI5Ehrf82ybkUcsA&s",
              googleKeyword: "Valencia City of Arts",
            },
            {
              name: "Bilbao",
              state: "Basque Country",
              type: "Cultural/Modern",
              famousFor: "Guggenheim Museum",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjj_CkkS5wFWRNmuZNYbEG2GDYaz8FUZ-Huw&s",
              googleKeyword: "Bilbao Guggenheim Museum",
            },
            {
              name: "Toledo",
              state: "Castile-La Mancha",
              type: "Historical/Religious",
              famousFor: "Toledo Cathedral, Ancient Walls",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRpTdpURX6g78Jx4iukwXqQ5JbcGGZ2c60r1A&s",
              googleKeyword: "Toledo Cathedral Spain",
            },
            {
              name: "Santiago de Compostela",
              state: "Galicia",
              type: "Pilgrimage/Religious",
              famousFor: "Way of St. James, Cathedral",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_9RCNDzgHczPIHcUb7h822G3HUsKG9RbdzA&s",
              googleKeyword: "Santiago de Compostela Cathedral",
            },
          ],
        },
      },
      {
        name: "Turkey",
        regions: {
          Cities: [
            {
              name: "Istanbul",
              state: "Istanbul",
              type: "Historical/Cultural",
              famousFor: "Hagia Sophia, Bosphorus",
              image:
                "https://cdn.britannica.com/58/93158-050-7719EB2B/view-Blue-Mosque-Istanbul-Hagia-Sophia.jpg",
              googleKeyword: "Hagia Sophia Istanbul",
            },
            {
              name: "Cappadocia",
              state: "Nevşehir",
              type: "Adventure/Scenic",
              famousFor: "Hot Air Balloons, Cave Hotels",
              image:
                "https://cdn.britannica.com/83/153483-050-CCB7472B/formations-cave-city-Cappadocia-Turkey.jpg",
              googleKeyword: "Cappadocia Hot Air Balloon",
            },
            {
              name: "Antalya",
              state: "Antalya",
              type: "Beach/Resort",
              famousFor: "Turquoise Coast, Roman Ruins",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8QPtr_MPwKDRPfeOKaJAxUofNHbJhCHpCug&s",
              googleKeyword: "Antalya Beach Turkey",
            },
            {
              name: "Pamukkale",
              state: "Denizli",
              type: "Natural Wonder",
              famousFor: "Thermal Travertines",
              image:
                "https://cdn-imgix.headout.com/tour/34583/TOUR-IMAGE/df3c0f85-5748-454d-89fc-8fc5122bd6f6-18104-kusadasi-from-selcuk-kusadasi-izmir--pamukkale-full-day-tour-01.jpg?w=686.7&h=428.40000000000003&crop=faces&auto=compress%2Cformat&fit=min",
              googleKeyword: "Pamukkale Turkey",
            },
            {
              name: "Izmir",
              state: "Izmir",
              type: "Coastal/Modern",
              famousFor: "Agora Ruins, Clock Tower",
              image:
                "https://cdn.britannica.com/34/10734-050-29C0B3FE/Clock-tower-Izmir-Turkey.jpg",
              googleKeyword: "Izmir Clock Tower",
            },
            {
              name: "Bodrum",
              state: "Muğla",
              type: "Coastal/Nightlife",
              famousFor: "Castle of St. Peter, Beaches",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYHp8fwDlp_yPI3Jh8HDyeKO1Gfn5crNy3iw&s",
              googleKeyword: "Bodrum Castle Turkey",
            },
            {
              name: "Ephesus",
              state: "İzmir Province",
              type: "Historical/Ancient",
              famousFor: "Temple of Artemis, Library of Celsus",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTuY7OGY5oPZAmJk2wP64aeE8xChPoUA9lHkg&s",
              googleKeyword: "Ephesus Ancient City",
            },
            {
              name: "Trabzon",
              state: "Trabzon",
              type: "Nature/Religious",
              famousFor: "Sumela Monastery, Black Sea views",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQZYLK4PIn_RnXS79CMltkfwK2QUATSakzIA&s",
              googleKeyword: "Sumela Monastery Trabzon",
            },
          ],
        },
      },
      {
        name: "Netherlands",
        regions: {
          Cities: [
            {
              name: "Amsterdam",
              state: "North Holland",
              type: "Urban/Cultural",
              famousFor: "Canals, Van Gogh Museum",
              image:
                "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2e/b5/0b/4a/caption.jpg?w=1200&h=-1&s=1&cx=1920&cy=1080&chk=v1_1f5914ade620577562b5",
              googleKeyword: "Amsterdam Canals",
            },
            {
              name: "Rotterdam",
              state: "South Holland",
              type: "Modern/Architectural",
              famousFor: "Cube Houses, Erasmus Bridge",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS2rPPL6L1hWvYA8_wFyJVPW2orSiojbnAXVg&s",
              googleKeyword: "Rotterdam Cube Houses",
            },
            {
              name: "The Hague",
              state: "South Holland",
              type: "Political/Cultural",
              famousFor: "Peace Palace, Government",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnsC6RnFt0zgQqvHyh3EfRjDAIhW4pcDm94A&s",
              googleKeyword: "Peace Palace The Hague",
            },
            {
              name: "Utrecht",
              state: "Utrecht",
              type: "Historical/Student City",
              famousFor: "Dom Tower, Old Canal",
              image:
                "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/03/ef/d7/5b/grachtengebied.jpg?w=1000&h=1000&s=1",
              googleKeyword: "Utrecht Dom Tower",
            },
            {
              name: "Maastricht",
              state: "Limburg",
              type: "Historical/Cultural",
              famousFor: "Medieval Architecture, Treaty of Maastricht",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPCKwhS_EiWqpID7y0GDbQDY4R013YqH6siA&s",
              googleKeyword: "Maastricht Netherlands",
            },
            {
              name: "Delft",
              state: "South Holland",
              type: "Traditional/Art",
              famousFor: "Blue Pottery, Vermeer Museum",
              image:
                "https://lp-cms-production.imgix.net/2019-06/GettyImages-500741461_full.jpg?auto=format,compress&q=72&w=1095&fit=crop&crop=faces,edges",
              googleKeyword: "Delft Netherlands",
            },
            {
              name: "Leiden",
              state: "South Holland",
              type: "Historical/University",
              famousFor: "Leiden University, Canals",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQL1n0C5s_wISjO6irAwXjFsrsv-NJyMm3wYQ&s",
              googleKeyword: "Leiden Netherlands",
            },
            {
              name: "Giethoorn",
              state: "Overijssel",
              type: "Village/Nature",
              famousFor: "No Roads, Only Canals",
              image:
                "https://media.tacdn.com/media/attractions-splice-spp-674x446/11/d4/46/62.jpg",
              googleKeyword: "Giethoorn Netherlands",
            },
          ],
        },
      },
      {
        name: "Greece",
        regions: {
          Cities: [
            {
              name: "Athens",
              state: "Attica",
              type: "Historical/Urban",
              famousFor: "Acropolis, Parthenon",
              image:
                "https://www.grayline.com/wp-content/uploads/2025/03/Gray-Line-Athens-Cover-Photo-scaled.jpg",
              googleKeyword: "Acropolis Athens",
            },
            {
              name: "Santorini",
              state: "Cyclades",
              type: "Island/Romantic",
              famousFor: "Whitewashed Houses, Caldera",
              image:
                "https://lp-cms-production.imgix.net/2025-03/Shutterstock92342251.jpg?auto=format,compress&q=72&w=1440&h=810&fit=crop",
              googleKeyword: "Santorini Greece",
            },
            {
              name: "Mykonos",
              state: "Cyclades",
              type: "Island/Party",
              famousFor: "Beaches, Windmills",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqSxgLyykQDJJbIN1eGxVY5I0fAAaI1b5UYg&s",
              googleKeyword: "Mykonos Windmills",
            },
            {
              name: "Thessaloniki",
              state: "Central Macedonia",
              type: "Urban/Cultural",
              famousFor: "White Tower, Byzantine Walls",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTWMXFm9FDG4QS4XZDB-BPzsmvmbL56Eo2jbg&s",
              googleKeyword: "Thessaloniki Greece",
            },
            {
              name: "Delphi",
              state: "Phocis",
              type: "Historical/Sacred",
              famousFor: "Oracle Temple, Ruins",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQjxPrTFrJvzjuBfge5cs26z0yIYut-Nox9KQ&s",
              googleKeyword: "Delphi Greece",
            },
            {
              name: "Corfu",
              state: "Ionian Islands",
              type: "Island/Green",
              famousFor: "Old Town, Beaches",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQgakKNpDOzvTbIutbj8tCaAir4gKCAK9j91A&s",
              googleKeyword: "Corfu Island Greece",
            },
            {
              name: "Rhodes",
              state: "Dodecanese",
              type: "Island/Historical",
              famousFor: "Medieval Old Town",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRz04dXbZ5a2NzeZzQWd-8iuf4RtxqahQfj2g&s",
              googleKeyword: "Rhodes Old Town Greece",
            },
            {
              name: "Meteora",
              state: "Thessaly",
              type: "Monastic/Nature",
              famousFor: "Cliff-top Monasteries",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSLK3NEKxoDgBa-b_fNZwWHOLUhv_DmpzWWWA&s",
              googleKeyword: "Meteora Monasteries Greece",
            },
          ],
        },
      },
      {
        name: "Iceland",
        regions: {
          Cities: [
            {
              name: "Reykjavik",
              state: "Capital Region",
              type: "Urban/Nature Gateway",
              famousFor: "Hallgrimskirkja, Blue Lagoon",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBprU0kalLW1yXXQ_jub1TJ5EyMVgSFJEPzw&s",
              googleKeyword: "Reykjavik Iceland",
            },
            {
              name: "Akureyri",
              state: "North Iceland",
              type: "Town/Nature",
              famousFor: "Fjord Views, Botanical Gardens",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJPcyrvWKU7uS869peB5Nfyg0wpU-fG_zOCw&s",
              googleKeyword: "Akureyri Iceland",
            },
            {
              name: "Vik",
              state: "South Iceland",
              type: "Village/Natural Beauty",
              famousFor: "Black Sand Beach",
              image:
                "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0f/61/06/76/photo1jpg.jpg?w=1200&h=700&s=1",
              googleKeyword: "Vik Iceland Beach",
            },
            {
              name: "Húsavík",
              state: "Northeast Iceland",
              type: "Whale Watching",
              famousFor: "Whale Tours, Eurovision Movie",
              image:
                "https://www.carsiceland.com/assets/img/blog/264/featured/husavik-iceland-guide.webp",
              googleKeyword: "Husavik Whale Iceland",
            },
            {
              name: "Egilsstaðir",
              state: "East Iceland",
              type: "Remote/Nature",
              famousFor: "Forests, Eastern Fjords",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSOMNO_7Rp9b7DK9IAc-b_2uKQj3F7ku8sqjw&s",
              googleKeyword: "Egilsstadir Iceland",
            },
            {
              name: "Selfoss",
              state: "South Iceland",
              type: "Town/Near Attractions",
              famousFor: "Golden Circle Base",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdZT0tDLrRo63hVhdi_AMcBTKp96cNBhqLJw&s",
              googleKeyword: "Selfoss Iceland",
            },
            {
              name: "Ísafjörður",
              state: "Westfjords",
              type: "Remote/Fjord",
              famousFor: "Stunning Fjord Scenery",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3aLsUQirLGUt4fBCFY3PlncxJVafSd2WG6w&s",
              googleKeyword: "Isafjordur Iceland",
            },
            {
              name: "Hveragerði",
              state: "South Iceland",
              type: "Geothermal",
              famousFor: "Hot Springs, Greenhouses",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRVd6Scqe1CV5snDawsp0GU9Adwr0Wf6_4jeA&s",
              googleKeyword: "Hveragerdi Hot Springs",
            },
          ],
        },
      },
    ],
  },
  {
    continent: "North America",
    countries: [
      {
        name: "United States",
        regions: {
          Cities: [
            {
              name: "New York City",
              state: "New York",
              type: "Urban",
              famousFor: "Statue of Liberty, Times Square",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQz03kq4l7C3aF-RscCj_dIdG0htWb_3qmfUQ&s",
              googleKeyword: "Statue of Liberty New York",
            },
            {
              name: "Los Angeles",
              state: "California",
              type: "Urban/Entertainment",
              famousFor: "Hollywood, Beaches",
              image:
                "https://drupal-prod.visitcalifornia.com/sites/default/files/styles/fluid_1920/public/2020-06/VC_PlacesToVisit_LosAngelesCounty_RF_1170794243.jpg.webp?itok=46pJYz8v",
              googleKeyword: "Hollywood Los Angeles",
            },
            {
              name: "San Francisco",
              state: "California",
              type: "Urban",
              famousFor: "Golden Gate Bridge, Alcatraz",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7j3jISbOdT8Lsw8r65yOcSj8GL4JpPgYJhw&s",
              googleKeyword: "Golden Gate Bridge San Francisco",
            },
            {
              name: "Las Vegas",
              state: "Nevada",
              type: "Entertainment",
              famousFor: "Casinos, Shows",
              image:
                "https://res.cloudinary.com/dtljonz0f/image/upload/c_auto,ar_4:3,w_3840,g_auto/f_auto/q_auto/v1/gc-v1/las-vegas/LasVegas_banner_0?_a=BAVAZGE70",
              googleKeyword: "Las Vegas Strip",
            },
            {
              name: "Grand Canyon",
              state: "Arizona",
              type: "Natural",
              famousFor: "Grand Canyon National Park",
              image:
                "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Dawn_on_the_S_rim_of_the_Grand_Canyon_%288645178272%29.jpg/960px-Dawn_on_the_S_rim_of_the_Grand_Canyon_%288645178272%29.jpg",
              googleKeyword: "Grand Canyon National Park",
            },
            {
              name: "Orlando",
              state: "Florida",
              type: "Theme Parks",
              famousFor: "Disney World, Universal Studios",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTWDdc2ByNosP-G5ZqSAIhDqOzzqJpQlPcfrw&s",
              googleKeyword: "Disney World Orlando",
            },
            {
              name: "Washington D.C.",
              state: "District of Columbia",
              type: "Historical",
              famousFor: "White House, National Mall",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFs_6xKpqzxp08thq-aylI6XVa3B-xmWWSvSrFDcfVx27wLberYb6Zho--YzNKw_s9OJo&usqp=CAU",
              googleKeyword: "White House Washington DC",
            },
            {
              name: "Miami",
              state: "Florida",
              type: "Beach",
              famousFor: "South Beach, Art Deco District",
              image:
                "https://www.miamiandbeaches.com/getmedia/95fa4bbb-9a98-4367-a2ff-54bb97dbf267/mid-beach-aerial1-1440x900.jpg?width=600&resizemode=force",
              googleKeyword: "South Beach Miami",
            },
          ],
        },
      },
      {
        name: "Canada",
        regions: {
          Cities: [
            {
              name: "Toronto",
              state: "Ontario",
              type: "Urban",
              famousFor: "CN Tower, Toronto Islands",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQS6Ysw6m5KeM2cKgxQGaGOh7PUXpbwqOIfRg&s",
              googleKeyword: "CN Tower Toronto",
            },
            {
              name: "Vancouver",
              state: "British Columbia",
              type: "Urban/Natural",
              famousFor: "Stanley Park, Mountains",
              image:
                "https://ca-times.brightspotcdn.com/dims4/default/fe95225/2147483647/strip/true/crop/4800x3213+0+0/resize/1200x803!/quality/75/?url=https%3A%2F%2Fcalifornia-times-brightspot.s3.amazonaws.com%2F6c%2F3d%2F732446534aa2bd5b0c2e4cab0e04%2Fvancouver-dusk.jpeg",
              googleKeyword: "Stanley Park Vancouver",
            },
            {
              name: "Montreal",
              state: "Quebec",
              type: "Cultural",
              famousFor: "Old Montreal, Festivals",
              image:
                "https://static.seeker.io/media/img/1/289956ae-bbbe-45f2-96da-97fd639e60cb-1400.jpg?placeid=16680&name=Downtown%20Montreal,%20Montreal&lat=45.503479&lng=-73.568489",
              googleKeyword: "Old Montreal",
            },
            {
              name: "Banff",
              state: "Alberta",
              type: "Natural",
              famousFor: "Banff National Park",
              image:
                "https://cdn.sanity.io/images/lr9tta69/production/198eac2f1415070f1147b39a5528029399d97e9c-9504x6336.jpg?w=1920&q=77&fit=max&auto=format",
              googleKeyword: "Banff National Park",
            },
            {
              name: "Quebec City",
              state: "Quebec",
              type: "Historical",
              famousFor: "Old Quebec, Chateau Frontenac",
              image:
                "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/2b/56/82/91/old-quebec.jpg?w=600&h=400&s=1",
              googleKeyword: "Chateau Frontenac Quebec",
            },
            {
              name: "Whistler",
              state: "British Columbia",
              type: "Ski Resort",
              famousFor: "Winter Sports",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqPxqJ_yPBmGtGAYkjfAXYkLlCdJFGrbY1OQ&s",
              googleKeyword: "Whistler Ski Resort",
            },
            {
              name: "Niagara Falls",
              state: "Ontario",
              type: "Natural",
              famousFor: "Niagara Falls",
              image:
                "https://cdn.britannica.com/30/94430-050-D0FC51CD/Niagara-Falls.jpg",
              googleKeyword: "Niagara Falls",
            },
            {
              name: "Ottawa",
              state: "Ontario",
              type: "Political",
              famousFor: "Parliament Hill",
              image:
                "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0e/cf/57/e4/rideau-canal-skateway.jpg?w=600&h=-1&s=1",
              googleKeyword: "Parliament Hill Ottawa",
            },
          ],
        },
      },
      {
        name: "Mexico",
        regions: {
          Cities: [
            {
              name: "Cancun",
              state: "Quintana Roo",
              type: "Beach/Resort",
              famousFor: "Beaches, Nightlife",
              image:
                "https://www.agoda.com/wp-content/uploads/2024/03/Featured-image-Cancun-beach-with-resorts-Mexico.jpg",
              googleKeyword: "Cancun Beaches",
            },
            {
              name: "Mexico City",
              state: "Mexico City",
              type: "Urban/Heritage",
              famousFor: "Historic Center, Museums",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcScotmiKmV00tXlf4wdy5mgHu6sjn8jWY46FA&s",
              googleKeyword: "Historic Center Mexico City",
            },
            {
              name: "Tulum",
              state: "Quintana Roo",
              type: "Beach/Archaeological",
              famousFor: "Mayan Ruins, Beaches",
              image:
                "https://media.tacdn.com/media/attractions-splice-spp-674x446/06/e6/58/8c.jpg",
              googleKeyword: "Tulum Ruins",
            },
            {
              name: "Guadalajara",
              state: "Jalisco",
              type: "Cultural",
              famousFor: "Mariachi Music, Historic Sites",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQrCxr2qglJfUceYhFiHq_dB8eHJ4Zm6PAYpw&s",
              googleKeyword: "Mariachi Music Guadalajara",
            },
            {
              name: "Puerto Vallarta",
              state: "Jalisco",
              type: "Beach/Resort",
              famousFor: "Beaches, Art Scene",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTG4puhfBHVnzcoEsKlkM8vtuGIzxQjn2nj4Q&s",
              googleKeyword: "Puerto Vallarta Beaches",
            },
            {
              name: "Chichen Itza",
              state: "Yucatan",
              type: "Archaeological",
              famousFor: "Mayan Pyramid",
              image:
                "https://media-cdn.tripadvisor.com/media/attractions-splice-spp-674x446/06/e5/0a/8c.jpg",
              googleKeyword: "Chichen Itza",
            },
            {
              name: "Cabo San Lucas",
              state: "Baja California Sur",
              type: "Beach/Resort",
              famousFor: "Beaches, Marine Life",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUSXNQAED2w0vjkDIuQyaMZILFwQZrFKkhWw&s",
              googleKeyword: "Cabo San Lucas",
            },
            {
              name: "Oaxaca",
              state: "Oaxaca",
              type: "Cultural",
              famousFor: "Colonial Architecture, Cuisine",
              image:
                "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0d/c0/84/eb/vista-monte-alban.jpg?w=600&h=400&s=1",
              googleKeyword: "Oaxaca Mexico",
            },
          ],
        },
      },
    ],
  },
  {
    continent: "South America",
    countries: [
      {
        name: "Brazil",
        regions: {
          Cities: [
            {
              name: "Rio de Janeiro",
              state: "Rio de Janeiro",
              type: "Urban/Beach",
              famousFor: "Christ the Redeemer, Copacabana",
              image:
                "https://static.toiimg.com/thumb/103996442.cms?resizemode=75&width=1200&height=900",
              googleKeyword: "Christ the Redeemer Rio",
            },
            {
              name: "São Paulo",
              state: "São Paulo",
              type: "Urban",
              famousFor: "Skyscrapers, Culture",
              image:
                "https://media.istockphoto.com/id/1166728645/photo/suspension-bridge-cable-stayed-bridge-in-the-world.jpg?s=612x612&w=0&k=20&c=nkH7nRREwPfjcFuk40mbKOtQc3aoJiVIhD7TZpt25AI=",
              googleKeyword: "São Paulo city",
            },
            {
              name: "Iguaçu Falls",
              state: "Paraná",
              type: "Natural",
              famousFor: "Waterfalls",
              image:
                "https://cdn.britannica.com/04/175204-050-7F319F06/view-border-Iguacu-Falls-Argentina-Brazil.jpg",
              googleKeyword: "Iguazu Falls",
            },
            {
              name: "Salvador",
              state: "Bahia",
              type: "Cultural",
              famousFor: "Afro-Brazilian Culture",
              image:
                "https://media.istockphoto.com/id/539835430/photo/aerial-view-of-salvador-da-bahia-cityscape-bahia-brazil.jpg?s=612x612&w=0&k=20&c=WE5yPjJoNSZO_VB5W6C1YtuVRv_JPjRDKPJWi0k15CA=",
              googleKeyword: "Salvador Bahia",
            },
            {
              name: "Brasília",
              state: "Distrito Federal",
              type: "Planned City",
              famousFor: "Modern Architecture",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQkYZXhiDoOuFakRe5hIKXiD_KWyypg3VgNMw&s",
              googleKeyword: "Brasilia architecture",
            },
            {
              name: "Florianópolis",
              state: "Santa Catarina",
              type: "Beach",
              famousFor: "Surfing, Lagoons",
              image:
                "https://b3577058.smushcdn.com/3577058/wp-content/uploads/2021/10/custo-de-vida-em-florianopolis-720x511.jpg?lossy=1&strip=0&webp=1",
              googleKeyword: "Florianopolis beach",
            },
            {
              name: "Manaus",
              state: "Amazonas",
              type: "Amazon Rainforest",
              famousFor: "Gateway to Amazon",
              image:
                "https://www.shutterstock.com/image-photo/downtown-manaus-brazil-capital-city-600nw-2367996411.jpg",
              googleKeyword: "Manaus Amazon",
            },
            {
              name: "Recife",
              state: "Pernambuco",
              type: "Cultural/Beach",
              famousFor: "Historic Old Town, Beaches",
              image:
                "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Recife%2C_Brasil.jpg/250px-Recife%2C_Brasil.jpg",
              googleKeyword: "Recife Pernambuco",
            },
          ],
        },
      },
      {
        name: "Argentina",
        regions: {
          Cities: [
            {
              name: "Buenos Aires",
              state: "Buenos Aires",
              type: "Urban",
              famousFor: "Tango, Architecture",
              image:
                "https://cdn.britannica.com/63/188963-050-2C94FEC2/Night-view-obelisk-Buenos-Aires.jpg",
              googleKeyword: "Tango Buenos Aires",
            },
            {
              name: "Mendoza",
              state: "Mendoza",
              type: "Wine Region",
              famousFor: "Malbec Wine, Andes Views",
              image:
                "https://media.tacdn.com/media/attractions-splice-spp-674x446/06/71/91/ff.jpg",
              googleKeyword: "Mendoza vineyards",
            },
            {
              name: "Patagonia",
              state: "Santa Cruz",
              type: "Natural",
              famousFor: "Glaciers, Wildlife",
              image:
                "https://pictures.altai-travel.com/1920x0/lakes-in-patagonian-national-park-shutterstock-2344.jpg",
              googleKeyword: "Patagonia glaciers",
            },
            {
              name: "Iguazu Falls",
              state: "Misiones",
              type: "Natural",
              famousFor: "Waterfalls",
              image:
                "https://sevennaturalwonders.org/wp-content/uploads/2023/11/Iguazu-Falls-22-scaled.jpg",
              googleKeyword: "Iguazu Falls Argentina",
            },
            {
              name: "Bariloche",
              state: "Río Negro",
              type: "Mountain/Resort",
              famousFor: "Skiing, Lakes",
              image:
                "https://media.istockphoto.com/id/155152108/photo/overhead-view-of-san-carlos-de-bariloche-argentina.jpg?s=612x612&w=0&k=20&c=--KcHXCmNqBsRHk_1Gj9yNOFMWdHlu2qDsZcRxjeg8I=",
              googleKeyword: "Bariloche Argentina",
            },
            {
              name: "Cordoba",
              state: "Cordoba",
              type: "Cultural",
              famousFor: "Colonial Architecture",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRjtDD02N_RodH6KBtueG-Njyw-LhaR9Tt-Ow&s",
              googleKeyword: "Cordoba Argentina",
            },
            {
              name: "Ushuaia",
              state: "Tierra del Fuego",
              type: "Adventure",
              famousFor: "Southernmost City, Tierra del Fuego National Park",
              image:
                "https://i0.wp.com/turismoushuaia.com/wp-content/uploads/2018/05/NPX8550.jpg?fit=1024%2C684&ssl=1",
              googleKeyword: "Ushuaia Argentina",
            },
            {
              name: "La Boca",
              state: "Buenos Aires",
              type: "Cultural",
              famousFor: "Colorful Houses, Tango",
              image:
                "https://media-cdn.tripadvisor.com/media/attractions-splice-spp-674x446/06/96/6e/56.jpg",
              googleKeyword: "La Boca Buenos Aires",
            },
          ],
        },
      },
      {
        name: "Peru",
        regions: {
          Cities: [
            {
              name: "Machu Picchu",
              state: "Cusco Region",
              type: "Historical/Mountain",
              famousFor: "Ancient Inca City, UNESCO Site",
              image:
                "https://upload.wikimedia.org/wikipedia/commons/e/eb/Machu_Picchu%2C_Peru.jpg",
              googleKeyword: "Machu Picchu Peru",
            },
            {
              name: "Cusco",
              state: "Cusco",
              type: "Historical/Cultural",
              famousFor: "Inca Ruins, Spanish Colonial Architecture",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSzS0b8JhiNchOQJGFY-FcL5dxpfbO9aVURAw&s",
              googleKeyword: "Cusco Peru",
            },
            {
              name: "Lima",
              state: "Lima",
              type: "Urban/Coastal",
              famousFor: "Plaza Mayor, Miraflores, Museums",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSHbvLJf8DAN_ybn2ttFG6Amn5sCmlO38VVgQ&s",
              googleKeyword: "Lima Peru",
            },
            {
              name: "Arequipa",
              state: "Arequipa",
              type: "Colonial/Volcanic",
              famousFor: "White Stone Architecture, Misti Volcano",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQwmklRLNZOwXjIZwwEhb7xy-4Cj6cqj3rOzA&s",
              googleKeyword: "Arequipa Peru",
            },
            {
              name: "Puno",
              state: "Puno",
              type: "Lake/Traditional",
              famousFor: "Lake Titicaca, Uros Floating Islands",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ34wQtbwM5X5WFizDHWNXFuCxkGV03qPX6TA&s",
              googleKeyword: "Lake Titicaca Puno",
            },
            {
              name: "Nazca",
              state: "Ica",
              type: "Archaeological/Desert",
              famousFor: "Nazca Lines, Geoglyphs",
              image:
                "https://www.andbeyond.com/wp-content/uploads/sites/5/The-Hummingbird-Nazca-Lines-Peru.jpg",
              googleKeyword: "Nazca Lines Peru",
            },
            {
              name: "Iquitos",
              state: "Loreto",
              type: "Rainforest/River",
              famousFor: "Amazon Jungle Access, Boat Tours",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJOGCuDSAeZzbFqBk0Q80FsxgTQvD4aMUbvQ&s",
              googleKeyword: "Iquitos Amazon Peru",
            },
            {
              name: "Huaraz",
              state: "Ancash",
              type: "Mountain/Adventure",
              famousFor: "Hiking, Cordillera Blanca, Laguna 69",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTmzaihjj5z9nm1GwUHSBxKtyCZileZ6DVdaQ&s",
              googleKeyword: "Huaraz Laguna 69",
            },
          ],
        },
      },
      {
        name: "Chile",
        regions: {
          Cities: [
            {
              name: "Santiago",
              state: "Santiago Metropolitan",
              type: "Urban",
              famousFor: "City Life, Andes Views",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRHgECgzk0QW2G2Jvve4ImTEM6rh9CbWw8-_w&s",
              googleKeyword: "Santiago Chile",
            },
            {
              name: "Valparaíso",
              state: "Valparaíso",
              type: "Cultural",
              famousFor: "Colorful Hills, Port",
              image:
                "https://content.r9cdn.net/rimg/dimg/ef/8c/ff016182-city-835-16e60d10354.jpg?width=1366&height=768&xhint=1469&yhint=1033&crop=true",
              googleKeyword: "Valparaiso Chile",
            },
            {
              name: "Atacama Desert",
              state: "Antofagasta",
              type: "Natural",
              famousFor: "Driest Desert",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4VWbn4TB_v3YGjWa2ZqtDjy1ZqAUjppHg_A&s",
              googleKeyword: "Atacama Desert",
            },
            {
              name: "Torres del Paine",
              state: "Magallanes",
              type: "Natural",
              famousFor: "National Park, Mountains",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSahqY2-NsZpwWgsk32uO_sCtV46XLlcDMtrg&s",
              googleKeyword: "Torres del Paine",
            },
            {
              name: "Easter Island",
              state: "Valparaíso",
              type: "Cultural/Natural",
              famousFor: "Moai Statues",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTT1IErVQAcaNQ-3rBXupnnukc3MZyZWgDUDA&s",
              googleKeyword: "Easter Island",
            },
            {
              name: "Chiloé Island",
              state: "Los Lagos",
              type: "Cultural/Natural",
              famousFor: "Wooden Churches",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRHk6_g4DI6CneLEyjU03GU0BBtJar0f5A9UA&s",
              googleKeyword: "Chiloe Island",
            },
            {
              name: "Pucón",
              state: "Araucanía",
              type: "Adventure",
              famousFor: "Volcano, Hot Springs",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMVtPRyojxkYq2hDAqfHCpTgaQt3OSXESZDQ&s",
              googleKeyword: "Pucon Chile",
            },
            {
              name: "Valdivia",
              state: "Los Ríos",
              type: "Cultural/Natural",
              famousFor: "Rivers, Breweries",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ6hUc7E0fX_E7C60U5pBDpxcuTd2XtSw6JNQ&s",
              googleKeyword: "Valdivia Chile",
            },
          ],
        },
      },
    ],
  },
  {
    continent: "Africa",
    countries: [
      {
        name: "South Africa",
        regions: {
          Cities: [
            {
              name: "Cape Town",
              state: "Western Cape",
              type: "Urban/Natural",
              famousFor: "Table Mountain, Robben Island",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFjPzuso2sqMOJGjnY26-LcLcQDfOQ_40oYp4qArfyaKNZ3qmP4dxSdkRzknSj1dT3Zh4&usqp=CAU",
              googleKeyword: "Table Mountain Cape Town",
            },
            {
              name: "Johannesburg",
              state: "Gauteng",
              type: "Urban",
              famousFor: "Apartheid Museum, Gold Reef City",
              image:
                "https://going-cms-strapi.s3.amazonaws.com/64c697d90ac9042247083fed_jburg_Header_46ad516d26.webp",
              googleKeyword: "Apartheid Museum Johannesburg",
            },
            {
              name: "Kruger National Park",
              state: "Mpumalanga",
              type: "Wildlife",
              famousFor: "Safari, Big Five",
              image:
                "https://cdn.prod.website-files.com/636e23f049cf12406b2feccd/6757443b38b5ca43988ad8c9_66d9b87f199da438cee48ca8_Lion%2520Big%25205%2520.webp",
              googleKeyword: "Kruger National Park Safari",
            },
            {
              name: "Durban",
              state: "KwaZulu-Natal",
              type: "Beach",
              famousFor: "Beaches, Indian Ocean",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTq2AYzwQMz9OuJY9L8b4EgwbwW6tTvb5KKxw&s",
              googleKeyword: "Durban Beach",
            },
            {
              name: "Garden Route",
              state: "Western Cape",
              type: "Scenic",
              famousFor: "Coastline, Nature",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRvSCT5VtvJb7sAUR3vKIezjYpKK_-j5wVZ-g&s",
              googleKeyword: "Garden Route South Africa",
            },
            {
              name: "Robben Island",
              state: "Western Cape",
              type: "Historical",
              famousFor: "Nelson Mandela Prison",
              image:
                "https://upload.wikimedia.org/wikipedia/commons/2/24/Robben_Island_-_Cape_Town%2C_South_Africa_%283883849594%29.jpg",
              googleKeyword: "Robben Island",
            },
            {
              name: "Blyde River Canyon",
              state: "Mpumalanga",
              type: "Natural",
              famousFor: "Canyon, Scenic Views",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS72VHUXBIfsDq64qNmfWEYH54x_m4VQdZC5Q&s",
              googleKeyword: "Blyde River Canyon",
            },
            {
              name: "Addo Elephant National Park",
              state: "Eastern Cape",
              type: "Wildlife",
              famousFor: "Elephants, Safari",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRyuwhJooaQaRDH-FVZo0SrFQVjWI8c6Ef66Q&s",
              googleKeyword: "Addo Elephant National Park",
            },
          ],
        },
      },
      {
        name: "Egypt",
        regions: {
          Cities: [
            {
              name: "Cairo",
              state: "Cairo Governorate",
              type: "Urban/Heritage",
              famousFor: "Pyramids, Egyptian Museum",
              image:
                "https://www.worldatlas.com/upload/df/d5/97/shutterstock-2409522421.jpg",
              googleKeyword: "Pyramids Cairo",
            },
            {
              name: "Luxor",
              state: "Luxor Governorate",
              type: "Historical",
              famousFor: "Valley of the Kings, Temples",
              image:
                "https://images.getaroom-cdn.com/image/upload/s--_HwsX3_G--/c_limit,e_improve,fl_lossy.immutable_cache,h_460,q_auto:good,w_460/v1688588391/53c7083d71759cf008be86fb51e86c876c578b72?_a=BACAEuDL&atc=e7cd1cfa",
              googleKeyword: "Luxor Valley of the Kings",
            },
            {
              name: "Aswan",
              state: "Aswan Governorate",
              type: "Natural/Historical",
              famousFor: "Nile River, Temples",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTi1LA2vN6OgkFpQ_EyUjVAdZcN8Iw2LjiReQ&s",
              googleKeyword: "Aswan Nile River",
            },
            {
              name: "Alexandria",
              state: "Alexandria Governorate",
              type: "Coastal/Heritage",
              famousFor: "Library of Alexandria, Mediterranean Beaches",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQphwZwQqM280Mz7GWkVUwH_qRsrjGw3jNZ3g&s",
              googleKeyword: "Library of Alexandria",
            },
            {
              name: "Sharm El Sheikh",
              state: "South Sinai",
              type: "Resort",
              famousFor: "Red Sea Diving",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRlsYh0-tip2MuqDlJDsejUpu8MbJyv8cZ3ZA&s",
              googleKeyword: "Sharm El Sheikh",
            },
            {
              name: "Abu Simbel",
              state: "Aswan Governorate",
              type: "Historical",
              famousFor: "Temples of Abu Simbel",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSMWI4dpuXdSW_I-mau9UOlIjRd-AEb_DxPUA&s",
              googleKeyword: "Abu Simbel Temples",
            },
            {
              name: "Siwa Oasis",
              state: "Matrouh Governorate",
              type: "Natural/Desert",
              famousFor: "Oasis, Desert Landscape",
              image:
                "https://www.cleopatraegypttours.com/wp-content/uploads/2018/08/Siwa-Oasis.jpg",
              googleKeyword: "Siwa Oasis Egypt",
            },
            {
              name: "Hurghada",
              state: "Red Sea Governorate",
              type: "Beach/Resort",
              famousFor: "Beaches, Coral Reefs",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9fkISY9nKDI2VFfxAnHl9NJMH8iLUv9sOJIYWhNUNP2Xxa52iUSeG2j-WCIVYpTwJF5Y&usqp=CAU",
              googleKeyword: "Hurghada Red Sea",
            },
          ],
        },
      },
    ],
  },
  {
    continent: "Oceania",
    countries: [
      {
        name: "Australia",
        regions: {
          Cities: [
            {
              name: "Sydney",
              state: "New South Wales",
              type: "Urban",
              famousFor: "Sydney Opera House, Harbour Bridge",
              image:
                "https://businessevents.australia.com/content/businessevents/en/destinations/sydney/_jcr_content/hero/mobile.adapt.768.high.jpg",
              googleKeyword: "Sydney Opera House",
            },
            {
              name: "Melbourne",
              state: "Victoria",
              type: "Urban",
              famousFor: "Arts, Sports",
              image:
                "https://cdn.britannica.com/61/190461-050-4CF06506/Eureka-Tower-Melbourne.jpg",
              googleKeyword: "Melbourne city",
            },
            {
              name: "Great Barrier Reef",
              state: "Queensland",
              type: "Natural",
              famousFor: "Coral Reef",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEhk4yeklKlmtimgVxIh8SXea4Bn5OlBRViA&s",
              googleKeyword: "Great Barrier Reef",
            },
            {
              name: "Uluru",
              state: "Northern Territory",
              type: "Natural",
              famousFor: "Red Rock Formation",
              image:
                "https://cdn.britannica.com/51/99551-050-D8E072A4/face-Uluru-Ayers-Rock-Australia-Northern-Territory.jpg",
              googleKeyword: "Uluru",
            },
            {
              name: "Bondi Beach",
              state: "New South Wales",
              type: "Beach",
              famousFor: "Surfing",
              image:
                "https://media1.thrillophilia.com/filestore/21jb1ui2bdcmupy9z20o626wi1v7_1579339577_Bondi_Beach_Sydney.jpg",
              googleKeyword: "Bondi Beach",
            },
            {
              name: "Brisbane",
              state: "Queensland",
              type: "Urban",
              famousFor: "South Bank, River",
              image:
                "https://media.tacdn.com/media/attractions-splice-spp-674x446/09/79/47/d6.jpg",
              googleKeyword: "Brisbane city",
            },
            {
              name: "Hobart",
              state: "Tasmania",
              type: "Cultural/Natural",
              famousFor: "MONA, Mount Wellington",
              image:
                "https://i0.wp.com/aglobewelltravelled.com/wp-content/uploads/2014/06/Hobart-2-2.jpg?fit=1920%2C1280&ssl=1",
              googleKeyword: "Hobart Tasmania",
            },
            {
              name: "Perth",
              state: "Western Australia",
              type: "Urban/Beach",
              famousFor: "Swan River, Beaches",
              image:
                "https://www.flamingotravels.co.in/blog/wp-content/uploads/2025/02/Perth-Australia.jpg",
              googleKeyword: "Perth city",
            },
            {
              name: "Cairns",
              state: "Queensland",
              type: "Gateway to Great Barrier Reef",
              famousFor: "Tropical Climate, Diving",
              image:
                "https://www.tourismtown.com/images/hostedpage/50/ehqmYM2wDZK2Y-_1920x1293.jpg",
              googleKeyword: "Cairns Australia",
            },
            {
              name: "Alice Springs",
              state: "Northern Territory",
              type: "Outback",
              famousFor: "Gateway to Uluru",
              image:
                "https://indiaoutbound.info/wp-content/uploads/2020/06/Uluru_helicopter_view_cropped-scaled.jpg",
              googleKeyword: "Alice Springs",
            },
          ],
        },
      },
      {
        name: "New Zealand",
        regions: {
          Cities: [
            {
              name: "Auckland",
              state: "Auckland Region",
              type: "Urban",
              famousFor: "Sky Tower, Harbour",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ1gTrawmBUh2XqWJV1rPnh0FTOqNS0GAo-CQ&s",
              googleKeyword: "Auckland Sky Tower",
            },
            {
              name: "Wellington",
              state: "Wellington Region",
              type: "Capital City",
              famousFor: "Cultural Capital, Te Papa Museum",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXfMqZgJplbK0TrEHZQjvxZAiD3NM_viQX1A&s",
              googleKeyword: "Wellington Te Papa",
            },
            {
              name: "Christchurch",
              state: "Canterbury",
              type: "Urban",
              famousFor: "Botanic Gardens, Rebuild",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZlzZYblOUJ_fNmAHkK2dZrrefBfUN9Ok_OA&s",
              googleKeyword: "Christchurch city",
            },
            {
              name: "Queenstown",
              state: "Otago",
              type: "Adventure",
              famousFor: "Adventure Sports, Scenic Views",
              image:
                "https://www.datocms-assets.com/6737/1533735054-queenstown-viewtnz.jpg?auto=compress%2Cformat&crop=faces&fit=crop&fm=jpg",
              googleKeyword: "Queenstown New Zealand",
            },
            {
              name: "Rotorua",
              state: "Bay of Plenty",
              type: "Cultural/Natural",
              famousFor: "Geothermal Activity, Maori Culture",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSRZQsD9IjbLwm-qh4sJ6VmlolQWCBltHFB5g&s",
              googleKeyword: "Rotorua geothermal",
            },
            {
              name: "Milford Sound",
              state: "Fiordland",
              type: "Natural",
              famousFor: "Fiords, Scenic Cruises",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6BJwbyWK-5BeOrnNPpHlKIE1PHjlRCcB6Ydri_jDy0e9IFDcsMMHJj6IfkE2o84JsGWk&usqp=CAU",
              googleKeyword: "Milford Sound",
            },
            {
              name: "Bay of Islands",
              state: "Northland",
              type: "Natural",
              famousFor: "Beaches, Water Activities",
              image:
                "https://mustdonewzealand.co.nz/wp-content/uploads/2016/12/Otehei-Bay-day-trips-to-Urupukapuka-Island-Bay-of-Islands-15-560x460.jpg",
              googleKeyword: "Bay of Islands",
            },
            {
              name: "Dunedin",
              state: "Otago",
              type: "Cultural",
              famousFor: "Scottish Heritage, Wildlife",
              image:
                "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSZYTzeUPHAR3t1rBN0iDw7WBpq9LVOt1N6EA&s",
              googleKeyword: "Dunedin New Zealand",
            },
          ],
        },
      },
    ],
  },
];
